import React from "react";
import Countdown from "@/components/Countdown";
import WaitlistForm from "@/components/WaitlistForm";

export const Hero = () => {
    return (
        <section className="relative w-full" data-testid="hero-section">
            <div className="max-w-[1180px] mx-auto px-6 sm:px-10 lg:px-14 pt-28 sm:pt-40 lg:pt-48 pb-28 sm:pb-40">
                <div className="max-w-[920px] mx-auto text-center">
                    <h1
                        className="font-medium text-[56px] sm:text-[88px] lg:text-[112px] leading-[0.94] tracking-[-0.045em]"
                        style={{ color: "var(--plenum-text)" }}
                        data-testid="hero-headline"
                    >
                        Besser als jede
                        <br />
                        <span style={{ color: "var(--plenum-accent-2)" }}>
                            Umfrage.
                        </span>
                    </h1>

                    <p
                        className="mt-10 sm:mt-12 text-[18px] sm:text-[20px] leading-[1.45] max-w-[42ch] mx-auto"
                        style={{ color: "var(--plenum-muted-2)" }}
                        data-testid="hero-subtext"
                    >
                        Der Schweizer Abstimmungsmarkt. Bald live.
                    </p>

                    <p
                        className="mt-2 sm:mt-3 plenum-shimmer italic text-[14px] sm:text-[15px] leading-[1.5] tracking-[-0.005em] max-w-[58ch] mx-auto"
                        data-testid="hero-tagline"
                    >
                        Daten statt Bauchgefühl. Für die Schweizer Demokratie.
                    </p>

                    <div className="mt-12 sm:mt-14 max-w-[560px] mx-auto">
                        <WaitlistForm source="hero" testIdPrefix="hero" />
                    </div>

                    <div className="mt-10 sm:mt-12 max-w-[58ch] mx-auto">
                        <p
                            className="plenum-shimmer font-semibold text-[17px] sm:text-[18px] leading-[1.4] tracking-[-0.015em]"
                            data-testid="hero-founder-line"
                        >
                            Frühe Unterstützer erhalten einen lebenslangen
                            Founder-Badge.
                        </p>
                    </div>

                    <div className="mt-20 sm:mt-28">
                        <Countdown />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
